var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admonition',{staticClass:"pre-release-warning",attrs:{"type":"warning"}},[_vm._v("Versions starting with zero should be considered unstable and are subject to breaking changes at any time.")])
}
var staticRenderFns = []

export { render, staticRenderFns }